import { configureStore } from '@reduxjs/toolkit';

import { authReducer } from './auth.slice';
import { sessionReducer } from './session.slice';
import { clientReducer } from './client.slice';
import { utilizationReducer } from './utilization.slice';
import { providerReducer } from './provider.slice';
import { metricsReducer } from './metrics.slice';
import { facilityReducer } from './facility.slice';
import { timesheetReducer } from './timesheet.slice';
import { serviceCodeReducer } from './service_code.slice';
import { claimInvoiceReducer } from './claimInvoice.slice';
import { payorReducer } from './payor.slice';
import { parentSupervisionReducer } from './supervision-notes/parentSupervision.slice';
import { groupParentSupervisionReducer } from './supervision-notes/groupParentSupervisions.slice';
import { clientAssessmentReducer } from './supervision-notes/assessmentNotes.slice';
import { behaviorReducer } from './behaviors.slice';
import { medicationsReducer } from './treatment-plan/medications.slice';
import { assessmentReducer } from './treatment-plan/initialAssessment.slice';
import { maladaptiveBehaviorReducer } from './treatment-plan/maladaptiveBehavior.slice';
import { dischargeTransitionReducer } from './treatment-plan/dischargeTransition.slice';
import { treatmentPlanReducer } from './treatment-plan/treatmentPlan.slice';
import { crisisPlanReducer } from './treatment-plan/crisisPlan.slice';
import { goalReducer } from './treatment-plan/goals.slice';
import { symptomReducer } from './treatment-plan/symptoms.slice';
import { medicalHistoryReducer } from './treatment-plan/medicalHistory.slice';
import { educationBackgroundReducer } from './treatment-plan/educationBackgrounds.slice';
import { clientFamilyBackgroundReducer } from './treatment-plan/clientFamilyBackgrounds.slice';
import { treatmentRecommendationReducer } from './treatment-plan/treatmentRecommendation.slice';
import { abaTherapyServicesReducer } from './treatment-plan/abaTherapy.slice';
import { clientSupervisionReducer } from './supervision-notes/clientSupervisions.slice';
import { btSupervisionReducer } from './supervision-notes/btSupervisions.slice';
import { providerAssignmentReducer } from './providerAssignment.slice';
import { claimsReducer } from './claims.slice';
import { payorProviderCredentialsReducer } from './payorProviderCredentials.slice';
import { cohortReducer } from './cohorts.slice';
import { featureFlagReducer } from './featureFlags.slice';
import { onboardingQuestionnaireReducer } from './questionnaires/onboarding';
import { intakeQuestionnaireReducer } from './questionnaires/intake';
import { emailCronConfigReducer } from './emailCronConfig.slice';
import { fieldTemplatesReducer } from './fieldTemplates/fieldTemplates.slice';
import { treatmentPlanV3Reducer } from './treatmentPlanV3';

export * from './auth.slice';
export * from './session.slice';
export * from './client.slice';
export * from './claimInvoice.slice';
export * from './utilization.slice';
export * from './provider.slice';
export * from './metrics.slice';
export * from './facility.slice';
export * from './timesheet.slice';
export * from './service_code.slice';
export * from './payor.slice';
export * from './supervision-notes/parentSupervision.slice';
export * from './supervision-notes/groupParentSupervisions.slice';
export * from './behaviors.slice';
export * from './treatment-plan/medications.slice';
export * from './treatment-plan/initialAssessment.slice';
export * from './treatment-plan/maladaptiveBehavior.slice';
export * from './treatment-plan/treatmentPlan.slice';
export * from './treatment-plan/crisisPlan.slice';
export * from './treatment-plan/goals.slice';
export * from './treatment-plan/symptoms.slice';
export * from './treatment-plan/medicalHistory.slice';
export * from './treatment-plan/educationBackgrounds.slice';
export * from './treatment-plan/clientFamilyBackgrounds.slice';
export * from './treatment-plan/dischargeTransition.slice';
export * from './treatment-plan/abaTherapy.slice';
export * from './treatment-plan/treatmentRecommendation.slice';
export * from './supervision-notes/clientSupervisions.slice';
export * from './supervision-notes/btSupervisions.slice';
export * from './supervision-notes/assessmentNotes.slice';
export * from './providerAssignment.slice';
export * from './claims.slice';
export * from './claims.slice';
export * from './payorProviderCredentials.slice';
export * from './cohorts.slice';
export * from './featureFlags.slice';
export * from './questionnaires/onboarding';
export * from './questionnaires/intake';
export * from './emailCronConfig.slice';
export * from './fieldTemplates/fieldTemplates.slice';
export * from './treatmentPlanV3';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    sessions: sessionReducer,
    clients: clientReducer,
    utilizations: utilizationReducer,
    providers: providerReducer,
    facilities: facilityReducer,
    timesheets: timesheetReducer,
    serviceCodes: serviceCodeReducer,
    payors: payorReducer,
    parentSupervision: parentSupervisionReducer,
    groupParentSupervision: groupParentSupervisionReducer,
    clientAssessment: clientAssessmentReducer,
    claimsInvoice: claimInvoiceReducer,
    treatmentPlans: treatmentPlanReducer,
    behaviors: behaviorReducer,
    medications: medicationsReducer,
    assessments: assessmentReducer,
    metrics: metricsReducer,
    maladaptiveBehavior: maladaptiveBehaviorReducer,
    crisisPlans: crisisPlanReducer,
    dischargeTransitions: dischargeTransitionReducer,
    goals: goalReducer,
    symptoms: symptomReducer,
    medicalHistories: medicalHistoryReducer,
    educationBackgrounds: educationBackgroundReducer,
    clientFamilyBackgrounds: clientFamilyBackgroundReducer,
    treatmentRecommendations: treatmentRecommendationReducer,
    abaTherapyServices: abaTherapyServicesReducer,
    clientSupervisions: clientSupervisionReducer,
    btSupervision: btSupervisionReducer,
    providerAssignment: providerAssignmentReducer,
    claims: claimsReducer,
    payorProviderCredentials: payorProviderCredentialsReducer,
    cohorts: cohortReducer,
    featureFlags: featureFlagReducer,
    onboardingQuestionnaire: onboardingQuestionnaireReducer,
    intakeQuestionnaire: intakeQuestionnaireReducer,
    emailCronConfigs: emailCronConfigReducer,
    fieldTemplates: fieldTemplatesReducer,
    treatmentPlanV3: treatmentPlanV3Reducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = (action: any) => any;
